import state from './state'
import * as getters from './getters'
import mutations from './mutations'
import * as actions from './actions'

const namespaced = true

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
}
